import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../../app/store/store';

import {
    TicketDepartmentType,
    TicketInfoType,
    TicketListItemType,
    TicketMessageType,
    TicketPriorityType,
    TicketStatusType,
} from '../ticket.types';

type InitialStateType = {
    ticketList: TicketListItemType[] | undefined;
    ticketInfo: TicketInfoType | undefined;
    ticketLoading: boolean;
    ticketPageNumber: number;
    ticketTotalPages: number;
    ticketTitle: string | undefined;
    ticketId: string | undefined;
    ticketStatus: TicketStatusType | undefined;
    ticketDepartment: TicketDepartmentType | undefined;
    ticketPriority: TicketPriorityType | undefined;
    sentMessage: TicketMessageType | undefined;
    editingMessage: TicketMessageType | undefined;
    isMessageError: boolean;
};

const initialState: InitialStateType = {
    ticketList: undefined,
    ticketInfo: undefined,
    ticketLoading: false,
    ticketPageNumber: 1,
    ticketTotalPages: 1,
    ticketTitle: undefined,
    ticketId: undefined,
    ticketStatus: undefined,
    ticketDepartment: undefined,
    ticketPriority: undefined,
    sentMessage: undefined,
    editingMessage: undefined,
    isMessageError: false,
};

const ticketSlice = createSlice({
    name: 'ticket',
    initialState,
    reducers: {
        setTicketList: (state, action) => {
            state.ticketList = action.payload;
        },
        setTicketInfo: (state, action) => {
            state.ticketInfo = action.payload;
        },
        setTicketLoading: (state, action) => {
            state.ticketLoading = action.payload;
        },
        setTicketPageNumber: (state, action) => {
            state.ticketPageNumber = action.payload;
        },
        setTicketTotalPages: (state, action) => {
            state.ticketTotalPages = action.payload;
        },
        setTicketTitle: (state, action) => {
            state.ticketTitle = action.payload;
        },
        setTicketId: (state, action) => {
            state.ticketId = action.payload;
        },
        setTicketStatus: (state, action) => {
            state.ticketStatus = action.payload;
        },
        setTicketDepartment: (state, action) => {
            state.ticketDepartment = action.payload;
        },
        setTicketPriority: (state, action) => {
            state.ticketPriority = action.payload;
        },
        setSentMessage: (state, action) => {
            state.sentMessage = action.payload;
        },
        setEditingMessage: (state, action) => {
            state.editingMessage = action.payload;
        },
        setIsMessageError: (state, action) => {
            state.isMessageError = action.payload;
        },
    },
});

export const {
    setTicketList,
    setTicketInfo,
    setTicketLoading,
    setTicketPageNumber,
    setTicketTotalPages,
    setTicketTitle,
    setTicketId,
    setTicketStatus,
    setTicketDepartment,
    setTicketPriority,
    setSentMessage,
    setEditingMessage,
    setIsMessageError,
} = ticketSlice.actions;

export const ticketListSelector = (state: RootState) => state.ticket.ticketList;
export const ticketInfoSelector = (state: RootState) => state.ticket.ticketInfo;
export const ticketLoadingSelector = (state: RootState) =>
    state.ticket.ticketLoading;
export const ticketPageNumberSelector = (state: RootState) =>
    state.ticket.ticketPageNumber;
export const ticketTotalPagesSelector = (state: RootState) =>
    state.ticket.ticketTotalPages;
export const ticketTitleSelector = (state: RootState) =>
    state.ticket.ticketTitle;
export const ticketIdSelector = (state: RootState) => state.ticket.ticketId;
export const ticketStatusSelector = (state: RootState) =>
    state.ticket.ticketStatus;
export const ticketDepartmentSelector = (state: RootState) =>
    state.ticket.ticketDepartment;
export const ticketPrioritySelector = (state: RootState) =>
    state.ticket.ticketPriority;
export const sentMessageSelector = (state: RootState) =>
    state.ticket.sentMessage;
export const editingMessageSelector = (state: RootState) =>
    state.ticket.editingMessage;
export const isMessageErrorSelector = (state: RootState) =>
    state.ticket.isMessageError;

export default ticketSlice.reducer;
